import React, { useState } from 'react';

interface TooltipProps {
  children: React.ReactNode;
  content: string;
}

const Tooltip: React.FC<TooltipProps> = ({ children, content }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        className="cursor-help"
      >
        {children}
      </div>
      {isVisible && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-4 py-3 bg-gray-800 dark:bg-gray-100 border border-gray-700 dark:border-gray-300 text-white dark:text-gray-900 text-sm rounded-lg shadow-xl max-w-sm min-w-[200px] z-50">
          <div className="text-center leading-relaxed">{content}</div>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-8 border-transparent border-t-gray-800 dark:border-t-gray-100"></div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
